export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATE_ROLE_ERROR = 'CREATE_ROLE_ERROR';
export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';

export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_ERROR = 'DELETE_ROLE_ERROR';
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';

export const EDIT_ROLE = 'EDIT_ROLE';
export const EDIT_ROLE_ERROR = 'EDIT_ROLE_ERROR';
export const EDIT_ROLE_REQUEST = 'EDIT_ROLE_REQUEST';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';

export const GET_ROLE = 'GET_ROLE';
export const GET_ROLE_ERROR = 'GET_ROLE_ERROR';
export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST';
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS';

export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR';
export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';

export const SET_ROLE = 'SET_ROLE';
export const SET_ROLES = 'SET_ROLES';
